const addiesaas = window.addiesaas || (window.addiesaas = {});

export const ready = (callback) => {
  const addiesaasReady = addiesaas.ready || (addiesaas.ready = {callbacks: []})
  const callbacks = addiesaasReady.callbacks
  const readyType = typeof addiesaasReady
  if (readyType === 'function') {
    addiesaasReady(callback);
  } else {
    callbacks.push(callback);
  }
}

export default addiesaas
